<template>
  <vca-card>
    <ProfileHeader v-if="loaded" />
    <hr />
    <vca-row>
      <vca-card class="shadowed">
        <div class="vca-center avatar-container">
          <img :src="avatarURL" />
        </div>
      </vca-card>
      <ProfileData />
      <ProfileBulkRoles />
    </vca-row>
    <vca-row>
      <ProfileParticipants />
    </vca-row>
  </vca-card>
</template>

<script>
import ProfileData from "@/components/users/profile/ProfileData";
import ProfileHeader from "@/components/users/profile/ProfileHeader";
import { mapGetters } from "vuex";
import ProfileBulkRoles from "./profile/ProfileBulkRoles.vue";
import ProfileParticipants from "@/components/users/profile/ProfileParticipants.vue";
export default {
  name: "UserProfile",
  components: {
    ProfileHeader,
    ProfileData,
    ProfileBulkRoles,
    ProfileParticipants,
  },
  created() {
    this.$store
      .dispatch({
        type: "users/getById",
        data: this.current.id,
      })
      .then(() => {
        if (this.current.crew.organisation_id) {
          this.$store
            .dispatch({
              type: "organisations/getByID",
              data: this.current.crew.organisation_id,
            })
            .finally(() => {
              this.loaded = true;
            });
        } else {
          this.loaded = true;
        }
      });
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    ...mapGetters({
      current: "users/current",
    }),
    avatarURL() {
      if (this.current.avatar.file_id !== "") {
        return (
          process.env.VUE_APP_BACKEND_URL +
          "/users/avatar/img/" +
          this.current.avatar.file_id
        );
      } else {
        return "";
      }
    },
  },
};
</script>
